(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('[data-slider]');
    if (!slider) return;

    const track = slider.querySelector('.announcement-track');
    const slides = slider.querySelectorAll('.announcement-slide');
    const prev = slider.querySelector('[data-prev]');
    const next = slider.querySelector('[data-next]');

    let index = 0;
    let timer;
    const total = slides.length;

    function move() {
      track.style.transform = `translateX(-${index * 100}%)`;
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(() => {
        index = (index + 1) % total;
        move();
      }, 4000);
    }

    prev.addEventListener('click', () => {
      index = (index - 1 + total) % total;
      move();
      startAuto();
    });

    next.addEventListener('click', () => {
      index = (index + 1) % total;
      move();
      startAuto();
    });

    startAuto();
  });

  } catch(e) { console.error(e); }
})();
})();
